<script setup lang="ts">
const store = useCreditsDialogStore();
const router = useRouter();
const localePath = useLocalePath();

function goPricing() {
  store.close();
  const redirect = router.currentRoute.value.fullPath;
  router.push({ path: localePath('/pricing'), query: { redirect } });
}

// 打开时锁住 body 滚动
watch(() => store.visible, (v) => {
  if (typeof document === 'undefined') return;
  document.body.style.overflow = v ? 'hidden' : '';
});
</script>

<template>
  <Teleport to="body">
    <Transition name="fade">
      <div v-if="store.visible" class="overlay" @click.self="store.close()">
        <div class="box">
          <div class="icon">💳</div>
          <h3 class="title">Not enough credits</h3>
          <p class="msg">{{ store.message }}</p>
          <div class="actions">
            <button class="cancel-btn" @click="store.close()">Cancel</button>
            <button class="buy-btn" @click="goPricing">Get Credits</button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
}
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(90vw, 380px);
  border-radius: 1rem;
  background: #171717;
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 1.5rem;
  color: white;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}
.icon { font-size: 2.5rem; margin-bottom: 0.25rem; }
.title { font-size: 1.125rem; font-weight: 600; margin-top: 0.25rem; }
.msg { font-size: 0.875rem; color: rgba(255,255,255,0.7); text-align: center; margin-top: 0.5rem; }
.actions { display: flex; gap: 0.5rem; width: 100%; margin-top: 1.5rem; }
.cancel-btn, .buy-btn {
  flex: 1;
  height: 2.5rem;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.05s;
  border: none;
}
.cancel-btn {
  background: transparent;
  color: rgba(255,255,255,0.7);
  border: 1px solid rgba(255,255,255,0.15);
}
.cancel-btn:hover { background: rgba(255,255,255,0.05); }
.buy-btn {
  color: white;
  background: linear-gradient(135deg, #f97316 0%, #ea580c 50%, #c2410c 100%);
  box-shadow: 0 8px 24px -8px rgba(249,115,22,0.5);
}
.buy-btn:hover { opacity: 0.92; }
.buy-btn:active { transform: scale(0.98); }

.fade-enter-active, .fade-leave-active { transition: opacity 0.18s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
